<template>
  <div>
    <d-form>
      <d-form-row class="form-group">
        <d-col cols="12">
          <label>Título:</label>
          <d-form-input type="text" v-model="model.name" :state="hasErrorFiled('name')"/>
          <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group">
        <d-col cols="6">
          <label>Tipo de jogo:</label>
          <d-select v-model="model.type_id" :state="hasErrorFiled('type_id')">
            <option :value="option.id" v-for="option in types" :key="option.id">{{ option.name }}</option>
          </d-select>
          <d-form-invalid-feedback>Tipo é obrigatório</d-form-invalid-feedback>
        </d-col>
        <d-col cols="6">
          <label>Preço:</label>
          <d-input-group prepend="R$">
            <input-currency
              model-index="price"
              placeholder="Valor"
              :model="model"
            ></input-currency>
          </d-input-group>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group">
        <d-col cols="12">
          <label>Descrição:</label>
          <textarea rows="5" v-model="model.description" class="form-control"/>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group">
        <d-col cols="6">
          <label>Imagem destacada:</label>
          <upload-image :model.sync="model"/>
        </d-col>
        <d-col cols="6">
          <label>Imagem do carrosel:</label>
          <upload-image :model.sync="model.featured_image"/>
        </d-col>
      </d-form-row>
      <d-form-row class="position-relative" v-if="model.id">
        <d-col cols="12">
          <magazine-puzzles :type_id="model.type_id" />
        </d-col>
      </d-form-row>
    </d-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep, stringfy, getDateTimeUTCISO } from '_utils';
import mixin from '_common/mixins/ValidateForm';
import UploadImage from '_shared/UploadImage.vue';
import InputCurrency from '_shared/InputCurrency.vue';
import MagazineService from '_services/rest/modules/magazine';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import MagazinePuzzles from './MagazinePuzzles.vue';
import {
  MODEL,
  _LOAD_MODEL_,
} from './MagazineModel';

export default {
  name: 'magazine-form',
  mixins: [mixin],
  components: {
    UploadImage,
    InputCurrency,
    MagazinePuzzles,
    ConfirmationModal,
  },
  computed: {
    types() {
      const { types } = this.$store.state.puzzle;
      if (types.length) {
        return types;
      }
      return [];
    },
    status() {
      const { status } = this.$store.state.puzzle;
      if (status.length) {
        return status;
      }
      return [];
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      title: 'Confirmação',
      callback: null,
      message: 'Tem certeza que deseja continuar?',
      errors: {
        name: { required: false },
        type_id: { required: false },
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getTypesList',
      'getStatusList',
    ]),
    getOptions() {
      if (this.types.length === 0) {
        this.getTypesList();
      }
      if (this.status.length === 0) {
        this.getStatusList();
      }
    },
    draft() {
      this.model.status_id = 1;
      this.save();
    },
    publish() {
      this.model.status_id = 2;
      this.model.published_date = getDateTimeUTCISO(new Date());
      this.save();
    },
    save() {
      if (this.checkForm()) {
        this.model.slug = stringfy(this.model.name);
        this.model.published_date = getDateTimeUTCISO(this.model.published_date);
        this.model.featured_image = this.model.featured_image.image;
        MagazineService.save(this.model)
          .then(response => {
            this.$store.commit('setMagazine', response.data);
            this.$router.push({ name: 'admin-magazine-edit', params: { magazineId: response.data.id } });
          })
          .catch(error => {
            this.activeAlert({ message: error.message, theme: 'danger' });
          });
      }
    },
  },
  mounted() {
    this.getOptions();
    this._onLoadModel = model => { this.model = model; };
    Events.$on(_LOAD_MODEL_, this._onLoadModel);
  },
  beforeDestroy() {
    Events.$off(_LOAD_MODEL_, this._onLoadModel);
  },
};
</script>

<style lang="scss" scoped>
.input_arrow {
  width: 50px;
  justify-content: space-between;
  align-items: center;
  margin-right: 15px;
}
.arrows {
  &.top {
    transform: rotate(180deg);
  }
  &.right {
    transform: rotate(-90deg);
  }
  &.bottom {

  }
  &.left {
    transform: rotate(90deg);
  }
  &.top_left {
    transform: rotate(130deg);
  }
  &.top_right {
    transform: rotate(-130deg);
  }
  &.bottom_left {
    transform: rotate(45deg);
  }
  &.bottom_right {
    transform: rotate(-45deg);
  }
}
</style>
